import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../Components/constant/BaseUrl";

export const TOKEN_KEY = "jwtToken";

const raw = fetchBaseQuery({
  baseUrl,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

// Session expired or revoked -> sign out everywhere
const baseQuery = async (args, api, extra) => {
  const result = await raw(args, api, extra);
  if (result.error?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
    window.dispatchEvent(new CustomEvent("admin:session-expired"));
  }
  return result;
};

export const myApi = createApi({
  reducerPath: "myApi",
  baseQuery,
  tagTypes: [
    "me",
    "dashboard",
    "orders",
    "order",
    "customers",
    "products",
    "inventory",
    "categories",
    "banners",
    "homeTitle",
    "explore",
    "faq",
    "policy",
    "social",
    "coupons",
    "reviews",
    "transactions",
    "shipping",
    "settings",
    "subscribers",
    "staff",
  ],
  endpoints: () => ({}),
});
